<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :rowsPerPageItems="rowsPerPageItems"
        :pagination.sync="paginationData"
        :total-items="paginationData.totalItems"
        :rows-per-page-text="$t('rowsPerPage')"
        :class="{'data-table-mobile': $utils.isMobile(),'elevation-1': $utils.isNotMobile()}"
        :no-data-text="$filters.capitalize($t('noDataAvailable'))"
        :hide-headers="$utils.isMobile()"
        :hide-footer="true"
        :custom-sort="customSort"
    >
        <template v-slot:items="props">
            <tr v-if="$utils.isMobile()" @click="onRowClick(props.item)" :class="rowClass">
                <td :colspan="headers.length" class="pa-0">
                    <div class="dtm-cell mb-3 pa-2">
                        <div class="dtm-row" v-for="header in headers" :key="header.text">
                            <div class="dtm-header">{{header.text}}</div>
                            <div>
                                <template v-if="header.type === 'custom'">
                                    <slot :name="header.id" v-bind:item="props.item"></slot>
                                </template>
                                <template v-else>
                                    {{getValue(header, props.item, props.index)}}
                                </template>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-else
                @click="onRowClick(props.item)"
                :class="rowClass"
                :style="{cursor: rowClick ? 'pointer' : 'auto'}"
            >
                <td
                    v-for="header in headers"
                    :key="header.text"
                    :class="getClass(header, props.item)"
                    :style="getStyle(header, props.item)"
                >
                    <template v-if="header.type === 'custom'">
                        <slot :name="header.id" v-bind:item="props.item"></slot>
                    </template>
                    <template v-else>
                        {{getValue(header, props.item, props.index)}}
                    </template>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>
<script>
export default {
    name: 'SimpleDataTable',
    props: {
        headers: Array,
        items: Array,
        rowClick: Function,
        pagination: Object,
        rowClass: {
            type: String,
            default: ''
        },
        customSort: Function,
        rowsPerPageItems: {
            type: Array,
            default: () => [5, 10, 20, 50]
        },
        onPagination: Function
    },
    data () {
        let paginationData = this.pagination ? { ...this.pagination } : {}
        if (!paginationData.page) {
            paginationData.page = 1
        }
        if (!paginationData.rowsPerPage) {
            paginationData.rowsPerPage = this.rowsPerPageItems[0]
        }
        return {
            paginationData: paginationData
        }
    },
    methods: {
        onRowClick (rowData) {
            if (typeof this.rowClick === 'function') {
                this.rowClick(rowData)
            }
        },
        getValue (header, item, index) {
            if (header.$value) {
                return header.$value(item, index)
            } else {
                if (typeof header.value === 'function') {
                    return header.value(item, index)
                }
                return item[header.value]
            }
        },
        getClass (header, item) {
            let className = header.class ? header.class : ''
            className += header.$class ? ' ' + header.$class(item) : ''
            return className
        },
        getStyle (header, item) {
            let style = header.style ? header.style : ''
            style += header.$style ? header.$style(item) : ''
            return style
        }
    },
    watch: {
        pagination (val) {
            for (let i in val) {
                this.paginationData[i] = val[i]
            }
        },
        paginationData (val) {
            this.$emit('update:pagination', val)
        }
    }
}
</script>
<style scoped>
</style>
